

import React from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { MdOutlineMailOutline } from "react-icons/md";
import { GrLocation } from "react-icons/gr";


const ContactForm = () => {
  return (
    <>
      <section className="section-with-120px-margin">
        <div className="container">
          <div className="_2-column-block">
            <div
              data-w-id="ac1d49ad-2d65-3b75-245d-c1991bae50a8"
              style={{
                opacity: 1,
                transform:
                  "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                transformStyle: "preserve-3d",
              }}
              className="contact-block w-form"
            >
              <h3 className="_32px-text">Feel free to Message</h3>
              {/* Formspree Integration */}
              <form
                action="https://formspree.io/f/mwpldarw" // Replace with your Formspree endpoint
                method="POST"
                className="vertical-left-stretch-30px-gap full-width"
                aria-label="contact form"
              >
                <div className="input-field-wrapper-30px">
                  <input
                    className="input-rounded w-input"
                    maxLength="256"
                    name="First-Name"
                    placeholder="First Name"
                    type="text"
                    id="First-Name"
                    required
                  />
                  <input
                    className="input-rounded w-input"
                    maxLength="256"
                    name="Last-Name"
                    placeholder="Last Name"
                    type="text"
                    id="Last-Name"
                    required
                  />
                </div>
                <div>
                  <input
                    className="input-rounded w-input"
                    maxLength="256"
                    name="Subject"
                    placeholder="Subject"
                    type="text"
                    id="Subject"
                    required
                  />
                </div>
                {/* EMAIL */}
                <div>
                  <input
                    className="input-rounded w-input"
                    maxLength="256"
                    name="Email"
                    placeholder="Email"
                    type="text"
                    id="Email"
                    required
                  />
                </div>
                <div>
                  <textarea
                    id="Message"
                    name="Message"
                    maxLength="5000"
                    placeholder="Message"
                    className="input-rounded text-area w-input"
                  ></textarea>
                </div>
                <div className="vertical-left-top">
                  <input
                    type="submit"
                    value="Send Message"
                    className="contact-button w-button"
                  />
                </div>
              </form>
              <div
                className="success-message w-form-done"
                tabIndex="-1"
                role="region"
                aria-label="contact form success"
              >
                <div>Thank you! Your submission has been received!</div>
              </div>
              <div
                className="error-message w-form-fail"
                tabIndex="-1"
                role="region"
                aria-label="contact form failure"
              >
                <div>Oops! Something went wrong while submitting the form.</div>
              </div>
            </div>
            <div
              id="w-node-e71a12a0-0ca0-9aae-5ab6-5103ba44e03b-75999f86"
              data-w-id="e71a12a0-0ca0-9aae-5ab6-5103ba44e03b"
              style={{
                opacity: 1,
                transform:
                  "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                transformStyle: "preserve-3d",
              }}
              className="contact-info-block"
            >
              <h2 className="_24px-text">How can I help you?</h2>
              <div className="margin-bottom-10px">
                <p>
                  It is a long established fact that a reader will be distracted
                  by readable content.
                </p>
              </div>
              <div className="vertical-left-top-30px-gap">
                <div className="contact-info">
                  <div className="contact-icon-12px">
                    <GrLocation />
                  </div>
                  <div className="vertical-left-top-4px-gap">
                    <p className="_20px-text">Address</p>
                    <div className="_18px-text-600">Southpoint Kabalagala</div>
                  </div>
                </div>
                <div className="contact-info">
                  <div className="contact-icon-12px">
                    <MdOutlineMailOutline />
                  </div>
                  <div className="vertical-left-top-4px-gap">
                    <p className="_20px-text">Email Address</p>
                    <div className="_18px-text-600">info@eristar.com</div>
                  </div>
                </div>
                <div className="contact-info">
                  <div className="contact-icon-12px">
                    <FaPhoneAlt />
                  </div>

                  <div className="vertical-left-top-4px-gap">
                    <p className="_20px-text">Phone number</p>
                    <div className="_18px-text-600">+256 709 438 944</div>
                    <div className="_18px-text-600">+256 764 070 076</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactForm;